import MainFooter from './MainFooter';
import AuthFooter from './AuthFooter';

export { MainFooter, AuthFooter };
export default { MainFooter };
